import { CSSProperties } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import { grey } from '@mui/material/colors';

export default function DataRatesTNC({
  color = grey[100],
  showRatesWarning = false,
}: {
  color?: CSSProperties['color'];
  showRatesWarning?: boolean;
}) {
  const {
    palette: {
      secondary: { main },
    },
  } = useTheme();
  const linkStyle: CSSProperties = {
    color: main,
    textDecoration: 'none',
  };

  return (
    <Box textAlign="center" color={color}>
      {showRatesWarning ? (
        <Typography>Message & data rates may apply.</Typography>
      ) : null}

      <Typography>
        <Link
          id="privacy-policy"
          target="_blank"
          style={linkStyle}
          href="https://corp.narvar.com/privacy-policy"
        >
          Privacy Policy{' '}
        </Link>
        &{' '}
        <Link
          id="tnc"
          target="_blank"
          style={linkStyle}
          href="https://corp.narvar.com/terms"
        >
          Terms
        </Link>
      </Typography>
    </Box>
  );
}
